"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "LocalStorageClient", {
  enumerable: true,
  get: function () {
    return _localStorageClient.LocalStorageClient;
  }
});
var _localStorageClient = require("./localStorageClient");